export default __webpack_public_path__ + "static/media/map-2.f63906bf.jpg";